import { Descriptions, Flex } from "@/atoms"
import { useTranslation } from "@/hooks/useTranslation"
import { InformationPopover } from "@/molecules/InformationPopover"

export const AiRelatedInsightLabel = () => {
  const { Label } = Descriptions
  const { t } = useTranslation("translation", {
    keyPrefix: "aiRelated.insight"
  })

  return (
    <Flex gap={4} align="center">
      <Label>{t("label")}</Label>
      <InformationPopover.Popover
        placement="top"
        content={
          <InformationPopover.CommonTemplate>
            {t("labelTooltip")}
          </InformationPopover.CommonTemplate>
        }
      />
    </Flex>
  )
}
